'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var transitions = {};

exports.__exports = transitions;
